<script lang="ts">
  import type { HTMLInputAttributes } from 'svelte/elements';
  import { cn } from '../lib/cn';
  import { focusOnMount } from '../lib/focus';
  import { inputClass } from './form';

  let {
    class: className,
    value = $bindable(),
    element = $bindable(),
    autofocus,
    ...rest
  }: HTMLInputAttributes & { element?: HTMLInputElement } = $props();
</script>

<input bind:this={element} bind:value use:focusOnMount={autofocus} class={cn(...inputClass, className as string | undefined)} {...rest} />
